const metagenome = {
  title: "Metagenome Documentation",

  fields: [
    {
      title: "Project Name",
      description:
        "Provide a meaningful and unique name for your metagenomic analysis project. This name will be used to identify the analysis throughout the platform.",

      examples: [
        "Human_Gut_Microbiome",
        "Soil_Microbiome_Study",
        "Marine_Metagenome_Project",
      ],

      notes: [
        "Choose a descriptive project name.",
        "Avoid unnecessary special characters.",
        "The project name will appear in your dashboard and reports.",
      ],
    },

    {
      title: "Number of Samples",
      description:
        "Specify the total number of metagenomic samples included in the analysis. Credits are calculated automatically based on the number of samples.",

      examples: [
        "5",
        "20",
        "100",
      ],

      notes: [
        "Must be greater than zero.",
        "Ensure the sample count matches the uploaded manifest file.",
      ],
    },

    {
      title: "Short Notes",
      description:
        "Provide any additional information or special instructions that may help the bioinformatics team during analysis.",

      examples: [
        "Human gut microbiome samples.",
        "Paired-end Illumina sequencing.",
      ],

      notes: [
        "Optional field.",
        "Mention any specific analysis requirements if applicable.",
      ],
    },

    {
      title: "Manifest File",

      description:
        "The Manifest File specifies the sequencing files associated with each sample. You may either fill the table manually or upload a CSV template.",

      sections: [
        {
          title: "Fill Manually",

          description:
            "Enter the Sample ID, Forward Absolute Path, and Reverse Absolute Path directly in the table.",
        },

        {
          title: "Download Template",

          description:
            "Download the CSV template, populate it with your sample information, and upload it back into the application.",
        },

        {
          title: "Upload Template",

          description:
            "Upload the completed Manifest CSV file. The application automatically imports the data and populates the manifest table.",
        },
      ],

      notes: [
        "Sample IDs must be unique.",
        "Forward and Reverse paths must point to valid sequencing files.",
        "Supported format: CSV.",
        "Either manual entry or CSV upload may be used.",
      ],
    },

    {
      title: "Metadata File",

      description:
        "The Metadata File contains sample metadata used during downstream metagenomic analysis. Data may be entered manually or imported from a CSV template.",

      sections: [
        {
          title: "Fill Manually",

          description:
            "Provide the sample ID and status directly in the metadata table.",
        },

        {
          title: "Download Template",

          description:
            "Download the Metadata CSV template, populate the required information, and upload it.",
        },

        {
          title: "Upload Template",

          description:
            "Upload the completed Metadata CSV file to automatically populate the metadata table.",
        },
      ],

      notes: [
        "Supported format: CSV.",
        "Either manual entry or CSV upload may be used.",
        "The sample IDs should correspond to those provided in the Manifest File.",
      ],
    },

    {
      title: "Select Column",

      description:
        "Choose the metadata column that will be used for grouping samples during downstream metagenomic analysis.",

      examples: [
        "ID",
        "Status",
      ],

      notes: [
        "The selected column should contain meaningful grouping information.",
      ],
    },

    {
      title: "Select File Type",

      description:
        "Specify the sequencing file type provided for analysis.",

      examples: [
        "Raw File",
        "Filter File",
      ],

      notes: [
        "Select the option that matches the uploaded sequencing data.",
      ],
    },

    {
      title: "Select Database Type",

      description:
        "Choose the reference database used for taxonomic classification and downstream microbial analysis.",

      examples: [
        "GreenGenes",
        "SILVA",
        "Unite",
      ],

      notes: [
        "Choose the database appropriate for your experiment.",
        "Different databases are optimized for different microbial communities.",
      ],
    },
  ],
};

export default metagenome;